import React from 'react'
import { ScanModes } from '../utils/scanModeEnum'
import { useScan } from '../context/scanContext'
import TicketHistory from '../components/TicketHistory'
import ErrorScanResponse from '../components/ErrorScanResponse'
import ProductTicketScanResponse from '../components/ProductTicketScanResponse'
import AccessTicketScanResponse from '../components/AccessTicketScanResponse'

/** Aiguillage vers l'écran de réponse correspondant au mode de scan actif. */
const ScanResponse = ({ error, onCancel, isHistoryValidation }) => {
  const { scanMode } = useScan()

  if (error) {
    return <ErrorScanResponse message={error} onCancel={onCancel} />
  }

  if (isHistoryValidation) {
    return <TicketHistory onCancel={onCancel} />
  }

  if (scanMode === ScanModes.ACCESS) {
    return <AccessTicketScanResponse onCancel={onCancel} />
  }

  if (scanMode === ScanModes.PRODUCT) {
    return <ProductTicketScanResponse onCancel={onCancel} />
  }

  return (
    <ErrorScanResponse
      message="Aucun mode de scan n'est configuré."
      onCancel={onCancel}
    />
  )
}

export default ScanResponse
